import React, { useState } from 'react';
import Button from '../../Button/Button';
import Modal from '../Modal/Modal';
import styles from "./KycVerification.module.scss";
import verificationpic from "../../../../assets/images/verification.png";
import ThanksModal from '../ThanksModal/ThanksModal';

const KycVerification = ({ show, handleClose }) => {
    const [showThanks, setShowThanks] = useState(false);
    return (
        <>
            <Modal className={styles.verification_modal}
                show={show}
                handleClose={handleClose}
                title="Verification">
                <div className={styles.direct_sec}>
                    <div className={styles.deposit_img}>
                        <img src={verificationpic} alt="man-with-magnifier" />
                    </div>
                    <h2>Please do the KYC verification</h2>
                    <p>We received your document. Please give us 3-5 business days to verify it. As soon as we complete our review, we’ll send you an email.</p>
                </div>
                <Button
                    fluid
                    onClick={() => { handleClose(); setShowThanks(true) }}
                    className={styles.submit_btn}
                >Continue</Button>
            </Modal>
            <ThanksModal
                show={showThanks}
                handleClose={() => setShowThanks(false)}
            />
        </>
    )
}

export default KycVerification